import { Center, Flex, Icon, Tooltip } from '@chakra-ui/react';
import { LuInfo } from 'react-icons/lu';
import { KFormLabel } from '@/ui-library/components';
import { MarkdownSubtext } from '@/utils/MarkdownSubtext';

export const FormCustomLabel = ({ item = {} }) => {
  const {
    label,
    name,
    subLabel,
    labelStyles,
    subLabelStyles,
    type,
    labelInfoText,
    showLabel = true,
  } = item;
  if (['checkbox', 'switch'].includes(type)) return null;
  return (
    <>
      {label && showLabel && (
        <Flex alignItems="center" gap="6px">
          <KFormLabel
            htmlFor={String(name)}
            overflow="hidden"
            style={{ ...labelStyles }}
          >
            {label}
          </KFormLabel>
          {labelInfoText && (
            <Tooltip variant="default" label={labelInfoText}>
              <Center>
                <Icon as={LuInfo} />
              </Center>
            </Tooltip>
          )}
        </Flex>
      )}
      {subLabel && (
        <KFormLabel
          htmlFor={name}
          style={{ ...subLabelStyles }}
          variant="subLabel"
          requiredIndicator={null}
        >
          <MarkdownSubtext
            markdown={subLabel}
            bodyColor="currentColor"
            bg="transparent"
            p={0}
            m={0}
          />
        </KFormLabel>
      )}
    </>
  );
};
